import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Home from "@/pages/Home";
import PrintShop from "@/pages/PrintShop";
import CollectionsPage from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import ArtworkDetail from "@/pages/ArtworkDetail";
import About from "@/pages/About";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Commissions from "@/pages/Commissions";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ShippingReturns from "@/pages/ShippingReturns";
import PrintInformation from "@/pages/PrintInformation";
import FAQ from "@/pages/FAQ";
import ClosedPage from "@/pages/ClosedPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArtworks from "@/pages/admin/AdminArtworks";
import AdminArtworkEdit from "@/pages/admin/AdminArtworkEdit";
import AdminCollections from "@/pages/admin/AdminCollections";
import AdminJournal from "@/pages/admin/AdminJournal";
import AdminJournalEdit from "@/pages/admin/AdminJournalEdit";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminMessages from "@/pages/admin/AdminMessages";

import "@/index.css";

// Temporary maintenance mode — set to false to re-open the public gallery.
// Admin routes remain available regardless of this flag.
const GALLERY_CLOSED = true;

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            {!GALLERY_CLOSED && (
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/print-shop" element={<PrintShop />} />
                <Route path="/collections" element={<CollectionsPage />} />
                <Route path="/collections/:slug" element={<CollectionDetail />} />
                <Route path="/artwork/:slug" element={<ArtworkDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalPost />} />
                <Route path="/commissions" element={<Commissions />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/shipping-and-returns" element={<ShippingReturns />} />
                <Route path="/print-information" element={<PrintInformation />} />
                <Route path="/faq" element={<FAQ />} />
              </Route>
            )}

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="artworks" element={<AdminArtworks />} />
              <Route path="artworks/new" element={<AdminArtworkEdit />} />
              <Route path="artworks/:id" element={<AdminArtworkEdit />} />
              <Route path="collections" element={<AdminCollections />} />
              <Route path="journal" element={<AdminJournal />} />
              <Route path="journal/new" element={<AdminJournalEdit />} />
              <Route path="journal/:id" element={<AdminJournalEdit />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="messages" element={<AdminMessages />} />
            </Route>

            {GALLERY_CLOSED && <Route path="*" element={<ClosedPage />} />}
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
